import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { AuthProvider } from './modules/auth/context/AuthContext'
import { 
  MockAuthBanner
} from './components/debug'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <MockAuthBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App